
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/beautyawards2024/result/ranking",
      function () {
        return require("private-next-pages/beautyawards2024/result/ranking.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/beautyawards2024/result/ranking"])
      });
    }
  